"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProgressBarIcon = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _designTokens = require("@smartsheet/design-tokens");
var _react = _interopRequireWildcard(require("react"));
var _Icon = require("../../icon/Icon");
var _ProgressBarSvg = _interopRequireDefault(require("./ProgressBarSvg"));
// Override the default sizing CSS custom properties with those for the ProgressBarIcon, but
// only if there are values.
const cssCustomProperties = {
  "--smar--ursa-icons--height": "var(--smar--ursa-icons--progress-bar--height, unset)",
  "--smar--ursa-icons--width": "var(--smar--ursa-icons--progress-bar--width, unset)"
};
const ProgressBarIcon = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    color = _designTokens.ursaColors.blue400,
    emptyFillColor = _designTokens.ursaColors.neutral00,
    size,
    value,
    ...rest
  } = _ref;
  const finalSize = {
    width: size?.width ? Number(size.width) : 71,
    height: size?.height ? Number(size.height) : 20
  };
  return /*#__PURE__*/_react.default.createElement(_Icon.Icon, (0, _extends2.default)({
    color: color,
    size: finalSize,
    ref: ref,
    cssCustomProperties: cssCustomProperties
  }, rest), /*#__PURE__*/_react.default.createElement(_ProgressBarSvg.default, {
    value: value,
    size: finalSize,
    emptyFillColor: emptyFillColor
  }));
});
exports.ProgressBarIcon = ProgressBarIcon;
ProgressBarIcon.displayName = "ProgressBarIcon";
//# sourceMappingURL=ProgressBarIcon.js.map